import { PaymentMethod } from '@modules/payment/models/paymentMethod.interface';
import {
  PaymentAction,
  PaymentTypes,
} from '@modules/payment/store/payment.action';
import { WebPayPreconditions } from '@modules/payment/models/webPayPreconditions.interfaces';
import { FormData } from '@codegen';

export class PaymentState {
  public paymentMethods: Array<PaymentMethod> | null;
  public payPrecondition: WebPayPreconditions | null;
  public webPayFormData: FormData[];
  public webPayRedirectUrl: string;
  public eripPath: string | null;
  public qrCodeLink: string | null;
  public currentPayment: number;
}

export function reducer(
  state = new PaymentState(),
  action: PaymentAction
): PaymentState {
  switch (action.type) {
    case PaymentTypes.SetPaymentMethods:
      return {
        ...state,
        paymentMethods: action.payload,
      };
    case PaymentTypes.SetPayPrecondition:
      return {
        ...state,
        payPrecondition: action.payload,
      };
    case PaymentTypes.SetWebPayFormData:
      return {
        ...state,
        webPayFormData: action.payload,
      };
    case PaymentTypes.SetWebPayRedirectUrl:
      return {
        ...state,
        webPayRedirectUrl: action.payload,
      };
    case PaymentTypes.SetEripPath:
      return {
        ...state,
        eripPath: action.payload,
      };
    case PaymentTypes.SetQrCodeLink:
      return {
        ...state,
        qrCodeLink: action.payload,
      };
    case PaymentTypes.SetCurrentPayment:
      return {
        ...state,
        currentPayment: action.payload,
      };
    default: {
      return state;
    }
  }
}
